(function () {
  function initStudyPlanner() {
    var root = document.getElementById('spc-root');
    if (!root) return;

    // Inject styles
    var style = document.createElement('style');
    style.textContent = [
      "@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Mono:wght@300;400;500&display=swap');",
      ".spc-wrap{font-family:'DM Mono',monospace;color:#0f2644;width:100%;max-width:540px;margin:0 auto}",
      ".spc-wrap *,.spc-wrap *::before,.spc-wrap *::after{box-sizing:border-box;margin:0;padding:0}",
      ".spc-card{border:2px solid #0f2644;box-shadow:5px 5px 0 #0f2644;position:relative;overflow:hidden}",
      ".spc-card::before{content:'';position:absolute;top:0;left:0;right:0;height:4px;background:#f32b29}",
      ".spc-header{padding:24px 28px 18px;border-bottom:1px solid #c2ccd8}",
      ".spc-supertitle{font-size:10px;font-weight:500;letter-spacing:.2em;text-transform:uppercase;color:#f32b29;margin-bottom:5px}",
      ".spc-title{font-family:'DM Serif Display',serif;font-size:26px;line-height:1.15;color:#0f2644;font-weight:normal}",
      ".spc-title em{font-style:italic;color:#f32b29}",
      ".spc-tabs{display:flex!important;border-bottom:1px solid #c2ccd8}",
      ".spc-tab{flex:1!important;display:block!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;padding:11px 14px!important;font-family:'DM Mono',monospace!important;font-size:11px!important;font-weight:500!important;letter-spacing:.08em!important;text-transform:uppercase!important;border:none!important;border-right:1px solid #c2ccd8!important;border-radius:0!important;background:#dde4ed!important;color:#5a6f87!important;cursor:pointer!important;transition:all .18s!important;line-height:1.3!important;text-align:center!important;outline:none!important;box-shadow:none!important}",
      ".spc-tab:last-child{border-right:none!important}",
      ".spc-tab.spc-active{background:#fff!important;color:#0f2644!important;box-shadow:inset 0 3px 0 #f32b29!important}",
      ".spc-tab:hover{background:#c8d2df!important;color:#0f2644!important}",
      ".spc-tab.spc-active:hover{background:#fff!important}",
      ".spc-panel{display:none!important;padding:24px 28px}",
      ".spc-panel.spc-active{display:block!important}",
      ".spc-field{margin-bottom:18px}",
      ".spc-field-label{display:block;font-size:10px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;color:#5a6f87;margin-bottom:6px}",
      ".spc-field input,.spc-field select{width:100%!important;padding:10px 13px!important;font-family:'DM Mono',monospace!important;font-size:14px!important;color:#0f2644!important;background:#edf1f6!important;border:1.5px solid #c2ccd8!important;border-radius:0!important;outline:none!important;transition:border-color .18s,background .18s;appearance:none!important;-webkit-appearance:none!important}",
      ".spc-field input:focus,.spc-field select:focus{border-color:#f32b29!important;background:#fff!important}",
      ".spc-select-wrap{position:relative}",
      ".spc-select-wrap::after{content:'▾';position:absolute;right:13px;top:50%;transform:translateY(-50%);pointer-events:none;color:#5a6f87;font-size:13px}",
      ".spc-field-row{display:grid;grid-template-columns:1fr 1fr;gap:12px}",
      ".spc-btn{display:block!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;width:100%!important;padding:12px 20px!important;font-family:'DM Mono',monospace!important;font-size:11px!important;font-weight:500!important;letter-spacing:.18em!important;text-transform:uppercase!important;background:#0f2644!important;color:#e8edf4!important;border:2px solid #0f2644!important;border-radius:0!important;cursor:pointer!important;transition:all .18s!important;margin-top:2px!important;text-align:center!important;outline:none!important}",
      ".spc-btn:hover{background:#f32b29!important;border-color:#f32b29!important;transform:translate(-2px,-2px)!important;box-shadow:4px 4px 0 #0f2644!important}",
      ".spc-btn:active{transform:translate(0,0)!important;box-shadow:none!important}",
      ".spc-result{margin-top:20px;padding:16px 18px;background:#dde4ed;border-left:4px solid #f32b29;display:none;animation:spcSlide .22s ease}",
      ".spc-result.spc-visible{display:block}",
      "@keyframes spcSlide{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}",
      ".spc-result-title{font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:#5a6f87;margin-bottom:10px}",
      ".spc-stats{display:flex;gap:28px;flex-wrap:wrap;margin-bottom:4px}",
      ".spc-stat{display:flex;align-items:baseline;gap:7px}",
      ".spc-num{font-family:'DM Serif Display',serif;font-size:30px;color:#f32b29;line-height:1}",
      ".spc-unit{font-size:12px;color:#5a6f87}",
      ".spc-note{margin-top:10px;font-size:12px;color:#3d556e;line-height:1.65;border-top:1px solid #c2ccd8;padding-top:10px}",
      ".spc-error{display:none;margin-top:10px;font-size:12px;color:#f32b29;letter-spacing:.04em}",
      ".spc-error.spc-visible{display:block}"
    ].join('');
    document.head.appendChild(style);

    // Inject HTML
    root.innerHTML = [
      '<div class="spc-card">',
        '<div class="spc-header">',
          '<div class="spc-supertitle">Study Planner</div>',
          '<div class="spc-title">Exam <em>Readiness</em> Calculator</div>',
        '</div>',
        '<div class="spc-tabs">',
          '<button type="button" class="spc-tab spc-active" id="spc-tab-date">I have an exam date</button>',
          '<button type="button" class="spc-tab" id="spc-tab-sched">I have a schedule</button>',
        '</div>',
        '<div class="spc-panel spc-active" id="spc-panel-date">',
          '<div class="spc-field">',
            '<label class="spc-field-label" for="spc-exam-date">Exam Date</label>',
            '<input type="date" id="spc-exam-date" />',
          '</div>',
          '<div class="spc-field">',
            '<label class="spc-field-label" for="spc-bg-date">Background Level</label>',
            '<div class="spc-select-wrap">',
              '<select id="spc-bg-date">',
                '<option value="">— Select level —</option>',
                '<option value="60">Beginner (60 hrs needed)</option>',
                '<option value="40">Some Background (40 hrs needed)</option>',
                '<option value="20">Strong Background (20 hrs needed)</option>',
              '</select>',
            '</div>',
          '</div>',
          '<button type="button" class="spc-btn" id="spc-btn-date">Calculate Study Plan</button>',
          '<div class="spc-error" id="spc-err-date">Please fill in all fields and choose a future date.</div>',
          '<div class="spc-result" id="spc-res-date">',
            '<div class="spc-result-title">Your Recommended Schedule</div>',
            '<div class="spc-stats">',
              '<div class="spc-stat"><span class="spc-num" id="spc-r-days"></span><span class="spc-unit">days / week</span></div>',
              '<div class="spc-stat"><span class="spc-num" id="spc-r-hrs"></span><span class="spc-unit">hrs / day</span></div>',
            '</div>',
            '<div class="spc-note" id="spc-note-date"></div>',
          '</div>',
        '</div>',
        '<div class="spc-panel" id="spc-panel-sched">',
          '<div class="spc-field">',
            '<label class="spc-field-label" for="spc-bg-sched">Background Level</label>',
            '<div class="spc-select-wrap">',
              '<select id="spc-bg-sched">',
                '<option value="">— Select level —</option>',
                '<option value="60">Beginner (60 hrs needed)</option>',
                '<option value="40">Some Background (40 hrs needed)</option>',
                '<option value="20">Strong Background (20 hrs needed)</option>',
              '</select>',
            '</div>',
          '</div>',
          '<div class="spc-field-row">',
            '<div class="spc-field">',
              '<label class="spc-field-label" for="spc-dpw">Days per Week</label>',
              '<input type="number" id="spc-dpw" min="1" max="7" placeholder="e.g. 5" />',
            '</div>',
            '<div class="spc-field">',
              '<label class="spc-field-label" for="spc-hpd">Hours per Day</label>',
              '<input type="number" id="spc-hpd" min="0.5" max="16" step="0.5" placeholder="e.g. 2" />',
            '</div>',
          '</div>',
          '<button type="button" class="spc-btn" id="spc-btn-sched">Calculate Exam Date</button>',
          '<div class="spc-error" id="spc-err-sched">Please fill in all fields with valid values.</div>',
          '<div class="spc-result" id="spc-res-sched">',
            '<div class="spc-result-title">Your Earliest Exam Date</div>',
            '<div class="spc-stat"><span class="spc-num" id="spc-r-examdate" style="font-size:22px;line-height:1.3"></span></div>',
            '<div class="spc-note" id="spc-note-sched"></div>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    // Set min date to tomorrow
    var dateInput = document.getElementById('spc-exam-date');
    var tmr = new Date();
    tmr.setDate(tmr.getDate() + 1);
    dateInput.min = tmr.toISOString().split('T')[0];

    // Tab switching
    document.getElementById('spc-tab-date').addEventListener('click', function () {
      document.getElementById('spc-tab-date').classList.add('spc-active');
      document.getElementById('spc-tab-sched').classList.remove('spc-active');
      document.getElementById('spc-panel-date').classList.add('spc-active');
      document.getElementById('spc-panel-sched').classList.remove('spc-active');
    });

    document.getElementById('spc-tab-sched').addEventListener('click', function () {
      document.getElementById('spc-tab-sched').classList.add('spc-active');
      document.getElementById('spc-tab-date').classList.remove('spc-active');
      document.getElementById('spc-panel-sched').classList.add('spc-active');
      document.getElementById('spc-panel-date').classList.remove('spc-active');
    });

    // Calculate study schedule from exam date
    document.getElementById('spc-btn-date').addEventListener('click', function () {
      var dateVal = document.getElementById('spc-exam-date').value;
      var hrs     = parseInt(document.getElementById('spc-bg-date').value, 10);
      var err     = document.getElementById('spc-err-date');
      var res     = document.getElementById('spc-res-date');

      err.classList.remove('spc-visible');
      res.classList.remove('spc-visible');

      if (!dateVal || !hrs) { err.classList.add('spc-visible'); return; }

      var parts     = dateVal.split('-');
      var exam      = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      var today     = new Date();
      today.setHours(0, 0, 0, 0);
      var daysUntil = Math.floor((exam - today) / 86400000);

      if (daysUntil < 1) { err.classList.add('spc-visible'); return; }

      var weeks = daysUntil / 7;
      var bestD = null, bestH = null, bestScore = Infinity;

      for (var d = 1; d <= 7; d++) {
        var loopHpd = hrs / (d * weeks);
        if (loopHpd < 0.25 || loopHpd > 10) continue;
        var score = Math.abs(d - 4) + Math.abs(loopHpd - 1.5) * 2;
        if (score < bestScore) { bestScore = score; bestD = d; bestH = loopHpd; }
      }

      if (!bestD) {
        document.getElementById('spc-r-days').textContent = '\u2014';
        document.getElementById('spc-r-hrs').textContent  = '\u2014';
        document.getElementById('spc-note-date').textContent = 'Not enough time \u2014 consider pushing your exam date back.';
      } else {
        document.getElementById('spc-r-days').textContent = bestD;
        document.getElementById('spc-r-hrs').textContent  = Math.round(bestH * 10) / 10;
        document.getElementById('spc-note-date').textContent =
          'You have ' + daysUntil + ' days (\u2248' + (Math.round(weeks * 10) / 10) +
          ' wks) until your exam. At this pace you\u2019ll cover all ' + hrs +
          ' hours needed for your level. Start today!';
      }
      res.classList.add('spc-visible');
    });

    // Calculate exam date from schedule
    document.getElementById('spc-btn-sched').addEventListener('click', function () {
      var hrs = parseInt(document.getElementById('spc-bg-sched').value, 10);
      var dpw = parseFloat(document.getElementById('spc-dpw').value);
      var hpd = parseFloat(document.getElementById('spc-hpd').value);
      var err = document.getElementById('spc-err-sched');
      var res = document.getElementById('spc-res-sched');

      err.classList.remove('spc-visible');
      res.classList.remove('spc-visible');

      if (!hrs || !dpw || !hpd || dpw < 1 || dpw > 7 || hpd <= 0) {
        err.classList.add('spc-visible'); return;
      }

      var hpw        = dpw * hpd;
      var daysNeeded = Math.ceil((hrs / hpw) * 7);
      var examDate   = new Date();
      examDate.setDate(examDate.getDate() + daysNeeded);

      document.getElementById('spc-r-examdate').textContent =
        examDate.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      document.getElementById('spc-note-sched').textContent =
        hpd + ' hr/day \u00d7 ' + dpw + ' day/wk = ' + (Math.round(hpw * 10) / 10) +
        ' hrs/week. You\u2019ll be ready in \u2248' + (Math.round((hrs / hpw) * 10) / 10) +
        ' weeks (' + daysNeeded + ' days), covering all ' + hrs + ' hours required for your level.';

      res.classList.add('spc-visible');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudyPlanner);
  } else {
    initStudyPlanner();
  }
})();